import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import './modal-signup.scss';
import { SignupForm } from '@widgets';
import { setModalSignupShowAC } from '@entities';
import { Icon } from '@ui-kit';
import CloseIcon from '@ui-kit/icons/x-gray700.svg';

const ModalSignup = () => {
  const dispatch = useDispatch();
  const ref = useRef();
  const referral = localStorage.getItem('referral');

  useEffect(() => {
    if(ref.current) {
      const mainWrapper = ref.current.parentNode ;
      mainWrapper.style = `overflow-y: hidden;`;
    }
  }, []);

  const onBackgroundClick = (e) => {
    if (e.target.id === 'signup-background') {
      closeModal();
    }
  };

  const closeModal = () => {
    dispatch(setModalSignupShowAC(false));
    const mainWrapper = ref.current.parentNode ;
    mainWrapper.style = '';
  };

  return (
    <div 
      id="signup-background" 
      className="signup-modal"
      ref={ref}
      onMouseDown={onBackgroundClick}
    >
      <div className="signup-modal__wrapper">
        <SignupForm referral={referral} />
        <div className="modal__close" onClick={closeModal}>
          <Icon src={CloseIcon} alt="close" />
        </div>
      </div>
    </div>
  );
};

export default ModalSignup;
